import { DayOfWeek } from "@pulse/pulse-rpcs/lib/email-cycle/dayOfWeek";
import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { DaysOfWeekValidationError } from "../enums/DaysOfWeekValidationError";

export const DaysOfWeekModel = types
  .model("DaysOfWeekModel", {
    value: types.array(
      types.enumeration("DayOfWeek", Object.values(DayOfWeek.DayOfWeek)),
    ),
    validationError: types.maybe(
      types.enumeration(
        "DaysOfWeekValidationError",
        Object.values(DaysOfWeekValidationError),
      ),
    ),
  })
  .actions((store) => ({
    setValue: (daysOfWeek: DayOfWeek.DayOfWeek[]): void => {
      store.validationError = daysOfWeek.length
        ? undefined
        : DaysOfWeekValidationError.EmptyValue;
      store.value.replace(daysOfWeek);
    },
  }));

export const createDaysOfWeekModel = (
  daysOfWeek?: SnapshotIn<typeof DaysOfWeekModel>,
): Instance<typeof DaysOfWeekModel> =>
  DaysOfWeekModel.create(daysOfWeek ?? { value: [] });
